import React from 'react';

import './style.scss';

const NodePersonTeaser = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], '');

  return (
    <div className="BaseTeaser NodePersonTeaser">
      {/* Start of title */}
      <div className="NodePersonTeaser__title">
        <div className="NodePersonTeaser__title__inner">
          {title}
        </div>
      </div>
      {/* End of Hero */}

      {/* Start of body */}
      <div className="row">
        <div className="col-12 NodePersonTeaser__inner">
          {body}
        </div>
      </div>
      {/* End of body */}
    </div>
  );
};

export default NodePersonTeaser;
